import React, { Component } from "react";
import Footer from "./components/Footer";
import logo from "./assets/images/logo2.png";
import Checkmark from "./components/Checkmark";

class Main extends Component {
  render() {
    return (
      <div className="App">
        <div className="Container">
          <img src={logo} alt="company logo" className="main__logo" />
          <div className="introduction">
            <p>
              Enjoying brave expeditions from back-end fortresses to the web and
              mobile frontiers and choosing the right tools for the quest at
              hand. Staying curious and open-minded helps us solve problems and
              deliver delightful user experiences.
            </p>
          </div>
          <div className="main">
            <div className="main__capabilities">
              <ul className="main__capabilities__list">
                <li>
                  <Checkmark />
                  <span>React (Native) development</span>
                </li>
                <li>
                  <Checkmark />
                  HTML / CSS / JS know-how
                </li>
                <li>
                  <Checkmark />
                  GraphQL / REST API's
                </li>
                <li>
                  <Checkmark />A person to have around
                </li>
                <li>
                  <Checkmark />
                  Agile delivery
                </li>
              </ul>
            </div>
            <div className="main__contact">
              <div className="main__contact__text">
                <p>Need help?</p>
              </div>
              <div className="main__contact__link">
                <a
                  href="mailto:help@facetank.fi"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Throw a message!
                </a>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}

export default Main;
